<template>
    <div class="puzzle-captcha-container">
      <label>Vérification : Placez la pièce manquante</label>
      <div class="puzzle-board" ref="puzzleBoard">
        <div class="puzzle-image" :style="{
          backgroundImage: `url(${holeImage || puzzleImage})`,
          backgroundSize: 'contain',
          backgroundRepeat: 'no-repeat',
          backgroundPosition: 'center'
        }"></div>
        <div class="puzzle-piece"
            :style="{ top: `${piecePosition.y}px`, left: `${piecePosition.x}px` }"
            @mousedown="startDrag"
            @touchstart="startDrag"
            ref="puzzlePiece">
            <img v-if="pieceImage" :src="pieceImage" draggable="false" alt="" style="width:100%;height:100%;display:block">
        </div>
    </div>
      <input type="hidden" :value="(piecePosition.x - marginLeft) + ',' + (piecePosition.y - marginTop)" name="puzzle_piece_position">
    </div>
  </template>

  <script>
  export default {
    name: 'PuzzleCaptcha',
    props: {
      puzzleImage: {
        type: String,
        required: true,
        default: '/puzzle-captcha.jpg'
      }
    },
    emits: ['verification-change'],
    data() {
        return {
            holeImage: '',
            pieceImage: '',
            piecePosition: { x: 0, y: 0 },
            //startPosition: { x: 0, y: 0 },
            isDragging: false,
            dragOffset: { x: 0, y: 0 },
            isValid: false,
            boardWidth: 0,
            boardHeight: 0,
            marginLeft: 0,
            marginTop: 0
        }
    },
    mounted() {
        // Attendre que l'image soit chargée
        setTimeout(() => {
            const board = this.$refs.puzzleBoard;
            const boardRect = board.getBoundingClientRect();
            const pieceSize = 60;

            // Calculer la taille réelle de l'image
            const img = new Image();
            img.src = this.puzzleImage;
            img.onload = () => {
            // Calculer le ratio d'aspect
            const imgRatio = img.width / img.height;
            const boardRatio = boardRect.width / boardRect.height;

            let displayedWidth, displayedHeight;
            if (boardRatio > imgRatio) {
                // La hauteur est limitante
                displayedHeight = boardRect.height;
                displayedWidth = displayedHeight * imgRatio;
            } else {
                // La largeur est limitante
                displayedWidth = boardRect.width;
                displayedHeight = displayedWidth / imgRatio;
            }

            // Calculer les marges
            const marginLeft = (boardRect.width - displayedWidth) / 2;
            const marginTop = (boardRect.height - displayedHeight) / 2;

            // Stockez les marges dans les données
            this.marginLeft = marginLeft;
            this.marginTop = marginTop;

            // Position initiale de la pièce
            this.piecePosition = {
                x: boardRect.width - pieceSize - 10,
                y: 10
            };

            // Stocker les dimensions pour la génération du puzzle
            this.boardWidth = displayedWidth;
            this.boardHeight = displayedHeight;

            // Charger le puzzle depuis le serveur (trou tiré et dessiné côté serveur)
            this.loadCaptcha();
            };
        }, 100);

        // Ajouter les événements globaux
        window.addEventListener('mousemove', this.onDrag);
        window.addEventListener('touchmove', this.onTouchDrag);
        window.addEventListener('mouseup', this.stopDrag);
        window.addEventListener('touchend', this.stopDrag);
        },
    beforeUnmount() {
      // Nettoyer les événements
      window.removeEventListener('mousemove', this.onDrag);
      window.removeEventListener('touchmove', this.onTouchDrag);
      window.removeEventListener('mouseup', this.stopDrag);
      window.removeEventListener('touchend', this.stopDrag);
    },
    methods: {
      startDrag(event) {
        if (event.touches) {
          event.preventDefault();
        }

        this.isDragging = true;
        const piece = this.$refs.puzzlePiece;
        const pieceRect = piece.getBoundingClientRect();

        if (event.type === 'mousedown') {
          this.dragOffset = {
            x: event.clientX - pieceRect.left,
            y: event.clientY - pieceRect.top
          };
        } else if (event.type === 'touchstart') {
          this.dragOffset = {
            x: event.touches[0].clientX - pieceRect.left,
            y: event.touches[0].clientY - pieceRect.top
          };
        }
      },
      onDrag(event) {
        if (!this.isDragging) return;
        if (event.buttons === 0) { this.stopDrag(); return; }

        const board = this.$refs.puzzleBoard;
        const boardRect = board.getBoundingClientRect();

        // Mettre à jour la position de la pièce
        this.piecePosition = {
          x: Math.max(0, Math.min(boardRect.width - 60, event.clientX - boardRect.left - this.dragOffset.x)),
          y: Math.max(0, Math.min(boardRect.height - 60, event.clientY - boardRect.top - this.dragOffset.y))
        };
      },
      onTouchDrag(event) {
        if (!this.isDragging) return;

        const board = this.$refs.puzzleBoard;
        const boardRect = board.getBoundingClientRect();

        // Mettre à jour la position de la pièce
        this.piecePosition = {
          x: Math.max(0, Math.min(boardRect.width - 60, event.touches[0].clientX - boardRect.left - this.dragOffset.x)),
          y: Math.max(0, Math.min(boardRect.height - 60, event.touches[0].clientY - boardRect.top - this.dragOffset.y))
        };
      },
      stopDrag() {
        if (!this.isDragging) return;

        this.isDragging = false;
        this.isValid = true;
        this.$emit('verification-change', true);
      },
      loadCaptcha() {
        fetch('/puzzle.php?w=' + this.boardWidth + '&h=' + this.boardHeight)
          .then(response => response.json())
          .then(data => {
            this.holeImage = data.hole;
            this.pieceImage = data.piece;
          })
          .catch(() => {
            // Échec visible : fond d'origine (sans trou), captcha invalide
            this.holeImage = '';
            this.pieceImage = '';
            this.isValid = false;
            this.$emit('verification-change', false);
          });
      },
      reload() {
        this.isValid = false;
        this.$emit('verification-change', false);
        this.piecePosition = { x: this.boardWidth - 70, y: 10 };
        this.loadCaptcha();
      }
    }
  }
  </script>

  <style scoped>
  .puzzle-captcha-container {
    margin: 20px 0;
    width: 100%;
  }

  .puzzle-board {
  position: relative;
  width: 100%;
  height: 200px;
  margin: 10px 0;
  border-radius: 4px;
  overflow: hidden;
 }

  .puzzle-image {
  width: 100%;
  height: 100%;
  background-size: contain;
  background-repeat: no-repeat;
  background-position: center;
  position: relative;
 }


  .puzzle-piece {
  position: absolute;
  width: 60px;
  height: 60px;
  cursor: move;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.2);
  border: 2px solid #4a90e2;
  border-radius: 2px;
  transition: box-shadow 0.2s;
  z-index: 10;
  overflow: hidden;
  user-select: none;
  -webkit-user-drag: none;
}


  .puzzle-piece:hover {
  box-shadow: 0 6px 12px rgba(0, 0, 0, 0.3);
  }

  </style>
